var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m18.255 14.915.262-1.885q.121-.868.22-1.597c.135-1 .203-1.5-.096-1.841-.3-.342-.813-.342-1.84-.342H7.199c-1.027 0-1.54 0-1.84.342-.298.342-.231.841-.096 1.84.065.487.14 1.017.22 1.598l.262 1.885c.285 2.048.428 3.073.73 3.895.565 1.539 1.542 2.685 2.709 3.177.623.263 1.354.263 2.816.263s2.193 0 2.816-.263c1.167-.492 2.144-1.638 2.709-3.177.302-.822.445-1.847.73-3.895",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5a4.75 4.75 0 0 0-4.75 4.75v.25H4A.75.75 0 0 0 4 8h16a.75.75 0 0 0 0-1.5h-3.25v-.25A4.75 4.75 0 0 0 12 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.75 11.25a.75.75 0 0 0-1.5 0v8a.75.75 0 0 0 1.5 0zm4 0a.75.75 0 0 0-1.5 0v8a.75.75 0 0 0 1.5 0z",
    clipRule: "evenodd"
  })));
};
export { SvgTrash as ReactComponent };